module.exports = __webpack_public_path__ + "static/media/HDLG-logo.91c27eb8.jpg";